import CryptoJS from "crypto-js";
import { ref, computed } from "vue";

const key = process.env.VUE_APP_DAEMON_KEY;
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export default function useEncryption() {
  function encryptionPassword(password) {
    password = btoa(
      CryptoJS.AES.encrypt(JSON.stringify(password), key, {
        format: CryptoJSAesJson,
      }).toString()
    );
    return password;
  }

  function decryptionPassword(password) {
    password = CryptoJS.AES.decrypt(atob(password), key, {
      format: CryptoJSAesJson,
    }).toString(CryptoJS.enc.Utf8);
    return password;
  }

  /**
   * Vue-friendly password visibility toggle.
   * Returns reactive state — bind to template via :type and :class.
   *
   * Usage (script setup):
   *   const { passwordVisible, togglePassword, passwordInputType, passwordIconClass } = usePasswordVisibility();
   *
   * Usage (template):
   *   <input :type="passwordInputType" />
   *   <i :class="passwordIconClass" @click="togglePassword" />
   */
  function usePasswordVisibility() {
    const passwordVisible = ref(false);
    const togglePassword = () => {
      passwordVisible.value = !passwordVisible.value;
    };
    const passwordInputType = computed(() =>
      passwordVisible.value ? "text" : "password"
    );
    const passwordIconClass = computed(() =>
      passwordVisible.value ? "bi bi-eye" : "bi bi-eye-slash"
    );
    return { passwordVisible, togglePassword, passwordInputType, passwordIconClass };
  }

  return { encryptionPassword, decryptionPassword, usePasswordVisibility };
}
